import { Modal } from '@/legacy/components/ui/Modals';
import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { Selector, MultiSelect } from '@/legacy/components/ui/Form/Select';
import { useCompanySwitchModal } from '../hooks/useCompanySwitchModal';

export type CompanySwitchModalProps = {
	isOpen: boolean;
	onClose: () => void;
};

const CompanySwitchModal = ({ isOpen, onClose }: CompanySwitchModalProps) => {
	const { t } = useTranslation('companySwitch');
	const {
		methods,
		onSubmit,
		companiesOptions,
		isLoadingCompanies,
		delegationsOptions,
		isLoadingDelegations,
		capabilities,
		isDelegationSelectionMandatory,
		onCompanySelect,
		userName,
		isPending,
	} = useCompanySwitchModal({ isOpen, onClose });

	// Neither companies nor delegations are switchable — the sidebar card already keeps this
	// modal from being opened, but stay defensive if something opens it directly.
	if (!capabilities.canOpenSwitcher) return null;

	return (
		<Modal
			title={t('modalTitle', { name: userName })}
			confirmText={t('confirm')}
			onConfirm={onSubmit}
			isOpen={isOpen}
			onClose={onClose}
			isLoading={isPending}
			buttonConfirmType='submit'
			onCancel={onClose}
		>
			<FormProvider
				{...methods}
				key={isOpen ? 'open' : 'closed'}
			>
				<form onSubmit={onSubmit}>
					{capabilities.canSwitchCompany && (
						<Selector
							name='company_id'
							label={t('companyLabel')}
							placeholder={t('companyPlaceholder')}
							options={companiesOptions}
							isLoadingOptions={isLoadingCompanies}
							searchable
							onSelect={onCompanySelect}
						/>
					)}
					{capabilities.canSwitchDelegations && (
						<MultiSelect
							name='delegations'
							label={t('delegationsLabel')}
							placeholder={t('delegationsPlaceholder')}
							options={delegationsOptions}
							isLoadingOptions={isLoadingDelegations}
							required={isDelegationSelectionMandatory}
							selectAllRow={false}
							pillsVariant
						/>
					)}
				</form>
			</FormProvider>
		</Modal>
	);
};

export default CompanySwitchModal;
